function extractDrawId(id?: string) {
  if (id) {
    return id?.split("#").at(-1);
  }
  return "";
}

export { extractDrawId };
